const HOURS = 24 * 60 * 60 * 1000;

// Initialize IndexedDB
const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('EventTrackerDB', 1);
    
    request.onerror = (event) => reject(event.target.error);
    request.onsuccess = (event) => resolve(event.target.result);
    
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('events')) {
        const store = db.createObjectStore('events', { keyPath: 'event' });
      }
    };
  });
};

// Delete old event
const deleteOldEvent = async (event) => {
  const db = await initDB();
  const transaction = db.transaction(['events'], 'readwrite');
  const store = transaction.objectStore('events');
  
  return new Promise((resolve, reject) => {
    const request = store.delete(event);
    request.onsuccess = () => resolve();
    request.onerror = (event) => reject(event.target.error);
  });
};

// Store new event
const storeEvent = async (event, data) => {
  const db = await initDB();
  const transaction = db.transaction(['events'], 'readwrite');
  const store = transaction.objectStore('events');
  
  const eventData = {
    event,
    data,
    timestamp: Date.now()
  };
  
  return new Promise((resolve, reject) => {
    const request = store.put(eventData);
    request.onsuccess = () => resolve();
    request.onerror = (event) => reject(event.target.error);
  });
};

// Check if event exists and is within 24 hours
const checkEventExists = async (event) => {
  const db = await initDB();
  const transaction = db.transaction(['events'], 'readonly');
  const store = transaction.objectStore('events');
  
  return new Promise((resolve, reject) => {
    const request = store.get(event);
    request.onsuccess = () => {
      const eventData = request.result;
      
      if (!eventData) {
        resolve(false);
        return;
      }
      
      const now = Date.now();
      const isWithinHours = (now - eventData.timestamp) < HOURS;
      resolve(isWithinHours);
    };
    request.onerror = (event) => reject(event.target.error);
  });
};

export const checkInStore = async (event, data) => {
  try {
    const exists = await checkEventExists(event);
    
    if (exists) {
      return true;
    } else {
      await deleteOldEvent(event);
      await storeEvent(event, data);
      return false;
    }
  } catch (error) {
    return true;
  }
};

// Delete entire database
export const deleteEventDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase('EventTrackerDB');
    
    request.onsuccess = () => resolve();
    request.onerror = (event) => reject(event.target.error);
  });
};

